// Plan.jsx
import React from "react";
import { Box } from "@mui/material";
import PlanSidebar from "./PlanSidebar"; // adjust path if needed
import PlanMainContent from "./PlanMainContent";

const Plan = () => {
  return (
    <Box sx={{ display: "flex", minHeight: "45rem", px: 2, pt: 2 }}>
      <PlanSidebar />
      <PlanMainContent />
    </Box>
  );
};

export default Plan;
